export const retreivePaymentRequestCode = {
    "curl": {
      "request": `curl -X 'GET'
'https://demo-api.westpay.se/in-store/api/v1/transaction/23179050000956/status'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'`
    },
    "java": {
      "request": `import java.io.BufferedReader;
import java.io.IOException;
import java.io.InputStreamReader;
import java.net.HttpURLConnection;
import java.net.URL;
      
public class TransactionStatusExample {
    public static void main(String[] args) {
        String apiUrl = "https://demo-api.westpay.se/in-store/api/v1/transaction/2023179050000956/status";
        String authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
        String ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
      
        try {
            URL url = new URL(apiUrl);
            HttpURLConnection connection = (HttpURLConnection) url.openConnection();
            connection.setRequestMethod("GET");
            connection.setRequestProperty("accept", "text/plain");
            connection.setRequestProperty("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
            connection.setRequestProperty("Authorization", authorization);
      
            int responseCode = connection.getResponseCode();
            if (responseCode == HttpURLConnection.HTTP_OK) {
                BufferedReader reader = new BufferedReader(new InputStreamReader(connection.getInputStream()));
                StringBuilder responseBody = new StringBuilder();
                String line;
                while ((line = reader.readLine()) != null) {
                    responseBody.append(line);
                }
                reader.close();
      
                System.out.println("Response Body: " + responseBody.toString());
            } else {
                System.out.println("Request failed. Response Code: " + responseCode);
            }
      
            connection.disconnect();
        } catch (IOException e) {
            e.printStackTrace();
        }
    }
}`
    },
    "C#": {
      "request": `using System;
using System.IO;
using System.Net;

class TransactionStatusExample
{
    static void Main()
    {
        string apiUrl = "https://demo-api.westpay.se/in-store/api/v1/transaction/2023179050000956/status";
        string authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
        string ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";

        try
        {
            HttpWebRequest request = (HttpWebRequest)WebRequest.Create(apiUrl);
            request.Method = "GET";
            request.Headers["accept"] = "text/plain";
            request.Headers["Ocp-Apim-Subscription-Key"] = ocpApimSubscriptionKey;
            request.Headers["Authorization"] = authorization;

            HttpWebResponse response = (HttpWebResponse)request.GetResponse();

            if (response.StatusCode == HttpStatusCode.OK)
            {
                StreamReader reader = new StreamReader(response.GetResponseStream());
                string responseBody = reader.ReadToEnd();
                reader.Close();

                Console.WriteLine("Response Body: " + responseBody);
            }
            else
            {
                Console.WriteLine("Request failed. Response Code: " + response.StatusCode);
            }

            response.Close();
        }
        catch (Exception ex)
        {
            Console.WriteLine("Exception: " + ex.Message);
        }
    }
}`
    },
    "python": {
      "request": `import requests

url = "https://demo-api.westpay.se/in-store/api/v1/transaction/2023179050000956/status"
headers = {
    "accept": "text/plain",
    "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04",
    "Ocp-Apim-Subscription-Key": "76591d32138f4f60b580db9ec9167f1d"
}

try:
    response = requests.get(url, headers=headers)
    if response.status_code == 200:
        data = response.json()
        print("Response Body:", data)
    else:
        print("Request failed. Response Code:", response.status_code)
except Exception as e:
    print("Exception:", str(e))`
    },
    
    "JavaScript": {
      "request": `const axios = require('axios');

const url = 'https://demo-api.westpay.se/in-store/api/v1/transaction/2023179050000956/status';
const headers = {
  'accept': 'text/plain',
  'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04',
  'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d'
};

axios.get(url, { headers })
  .then(response => {
    const data = response.data;
    console.log('Response Body:', data);
  })
  .catch(error => {
    console.error('Error:', error.message);
  });`
    }
  };
  
export const retreivePaymentRequestCodeResponse = `{
    "transactionStatus": 0,
    "transactionType": 1,
    "onlineAPIRefId": "string",
    "receiptData": {
      "error": "string",
      "saleId": "string",
      "transactionId": "string",
      "terminalId": "string",
      "terminalIdObscured": "string",
      "currencyId": 0,
      "totalAmount": 0,
      "denialReason": "string",
      "transactionTime": "2023-07-25T11:05:19.387Z",
      "cashBackAmount": 0,
      "tipAmount": 0,
      "cardPaymentData": {
        "approvalCode": "string",
        "authorisationMethod": "string",
        "authorisingEntity": "string",
        "responseCode": "string",
        "financialInstitution": "string",
        "cardName": "string",
        "cardExpiryDate": "string",
        "isContactless": true,
        "cardholderObscuredPan": "string",
        "merchantObscuredPan": "string",
        "verificationMethod": "string",
        "acquirerName": "string",
        "acquirerReference": "string",
        "acquirerRefObscured": "string",
        "posEntryMode": "string",
        "debitCreditSelection": "string",
        "cardNumberAlias": "string",
        "loyaltyId": "string",
        "cardHolderString": "string",
        "emvData": {
          "aid": "string",
          "tvr": "string",
          "tsi": "string",
          "authResponseCode": "string",
          "panSequenceNumber": 0
        },
        "dccData": {
          "currencyCode": "string",
          "convertedAmount": 0,
          "convertedTipAmount": 0,
          "exponent": 0,
          "exchangeRate": "string",
          "rateProvider": "string",
          "source": "string",
          "timeStamp": "2023-07-25T11:05:19.387Z",
          "markupFormatted": "string",
          "markupDescription": "string",
          "cardScheme": "string",
          "merchantDisclaimer": "string",
          "cardholderDisclaimer": "string"
        }
      },
      "alternativePaymentData": {
        "alternativePaymentMethod": "string",
        "authorisationMethod": "string",
        "verificationMethod": "string",
        "financialInstitution": "string"
      }
    },
    "merchantData": {
      "name": "string",
      "address": "string",
      "city": "string",
      "zipCode": "string",
      "phoneNumber": "string",
      "helplineNumber": "string",
      "organisationNumber": "string"
    }
}`;
  